export default __webpack_public_path__ + "static/media/d3e30b44-8c5b-473d-8556-8c3eb4f72e1f.411ac8c1.png";